<template>
  <div class="container-content">
    <div class="home-container">
    </div>
    <div class="body-container">
      <div class="body-content">
        <span class="location">您现在所在的位置：检验检测>{{curr}}</span>
        <span  class="search" style="position:relative">
           <input
             placeholder="检验检测搜索"
             v-model="searchValue"/>
          <img @click="toCommon({name:'检验检测',level:'检测机构'})"
               style="width:20px;height:20px;position:absolute;top:20px;right:250px"
               src="../../assets/images/search.svg"/>
        </span>
      </div>
      <div class="content">
        <div class="content-left">
          <div class="headline">
            <div class="img">
              <img src="../../assets/images/icon/icon-jyjc.png" alt="">
            </div>
            <div class="word">
              <span class="character">检验检测</span>
              <span class="english">Inspection and testi</span>
            </div>
          </div>
          <div class="frame">
            <div class="industry" :class="{active: curr==='检测'}" @click="switchPage('检测')">检测</div>
          </div>
        </div><!--
        --><div class="content-right">
        <div class="list-head">
          <div class="state-head">{{curr}}</div>
          <div class="english-head">Testing</div>
        </div>
        <div class="details-list" v-if="curr=='检测'">
          <ul>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-10-23/555574.shtml">凝聚共识 共谋互赢 共话发展——IEC合格评定国际研讨会在沪召开</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-09-20/555497.shtml">中国认证认可协会到青岛分中心调研</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-09-19/555493.shtml">弘扬工匠精神，唱响中国质量</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-08-26/555404.shtml">国家市场监管总局质量发展局、缺陷产品管理中心到访中心开展汽车召回监管调研</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-10-25/555588.shtml">立足标准技术平台，推动行业绿色发展，促进优秀人才培养</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-10-24/555580.shtml">保质量、控风险、促发展、树品牌——中心召开2019年江苏家电企业质量工作会议</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-10-15/555555.shtml">应用数字化管理手段提质增效</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-10-09/555532.shtml">中心颁发首批家用燃气器具产品CCC认证证书</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-09-20/555496.shtml">中心参加2019年美国能源之星年会</a></li>
            <li><a href="https://www.cqc.com.cn/www/chinese/c/2019-08-27/555407.shtml">整合资源 贴心服务 赢得信任</a></li>
          </ul>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curr: '检测',
      searchValue: ''
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    toCommon (obj) {
      this.$store.commit('saveSearchInputValue', this.searchValue);
      this.$store.commit('saveNormalList', [])
      localStorage.setItem('filterValue', obj.name)
      this.$store.commit('saveFilterValue')
      this.$store.commit('saveIsHot', false)
      this.$store.commit('saveIsTopNav', false)
      this.$router.push({ path: '/commonList' })
      this.$store.commit('saveMultipleValue', obj.level)
      this.$store.commit('saveIsSliderNav', true)
    },
    switchPage (page) {
      this.curr = page;
    }
  }
};
</script>

<style lang="less" scoped>
  .container-content{
    width: 100%;
    // max-width: 1920px;
    .home-container{
      position: relative;
      height: 343.8px;
      width: 100%;
      background-size: 100%;
      background-position: center;
      background-image:url("../../assets/images/checkout.png");
      background-repeat: no-repeat;
    }
    .body-container{
      width:  @body-width;
      margin: 0 auto;
      .body-content{
        width: @body-width;
        line-height: 60px;
        background: #f5f5f5;
        margin: 30px auto 20px auto;
        padding-left: 24px;
        .search{
          input::-webkit-input-placeholder {
            padding-left: 40px;
            opacity: 0.5;
          }
          input{
            width:250px;height:38px;padding-left:30px;border:1px solid @color-base;
          }
          padding-right:26px;
          float:right;
          color:#808080;
          font-size:14px;
          font-weight:400;
          cursor:pointer
        }
        .location{
          font-size:14px;
          font-weight:400;
          color:rgba(0,0,0,0.65);
        }
      }
      .content{
        width:  @body-width;
        margin: 0 auto;
        padding-bottom: 120px;
        .content-left{
          display: inline-block;
          width: 244px;
          height: 464px;
          .headline{
            padding: 10px 30px;
            width:244px;
            height:64px;
            background-color: @color-base ;
            .img{
              vertical-align:middle;
              display: inline-block;
              margin-bottom: 30px;
              margin-right: 5px;
            }
            .word{
              display: inline-block;
              .character{
                display: block;
                font-size:18px;
                font-weight:500;
                color: #f5f5f5;
              }
              .english{
                font-size:12px;
                font-weight:400;
                color:rgba(255,255,255,0.4);
              }
            }
          }
          .frame{
            width:220px;
            height:400px;
            background:#f5f5f5;
            padding: 20px 24px;
            .state{
              padding-left: 14px;
              width:220px;
              line-height:36px;
              background-image: url("../../assets/images/icon/bj.svg");
              font-size:16px;
              font-weight:500;
              color:#f5f5f5;
            }
            .industry{
              cursor: pointer;
              padding-left: 14px;
              width:220px;
              line-height:36px;
              font-size:16px;
              font-weight:400;
              color:rgba(0,0,0,0.65);
            }
            .active {
              color:#f5f5f5;
              background-image: url("../../assets/images/icon/bj.svg");
            }
          }
        }
        .content-right{
          padding:24px 0 0 30px;
          vertical-align:top;
          display: inline-block;
          width: 954px;
          min-height: 464px;
          border: 1px solid rgba(0, 0, 0, .1);
          margin-left: -1px;
          .list-head{
            height: 40px;
            border-bottom: 1px solid rgba(0,0,0,0.1);
            .state-head{
              display: inline-block;
              line-height: 18px;
              padding-right: 12px;
              font-size:18px;
              font-weight:500;
              color:@color-base;
              border-right: 1px solid #D8D8D8;
            }
            .english-head{
              margin-left: 12px;
              display: inline-block;
              font-size:16px;
              font-weight:400;
              color:rgba(102,181,255,0.65);
            }
          }
          .details-list{
            li:before {
        content: "\2022"; //圆点
        color: rgba(0, 0, 0, 0.25); //颜色
        font-size: 16px;
        padding-right: 8px; //大小
      }
            ul li {
              color: rgba(0,0,0,0.25);
              width:896px;
              line-height:54px;
              border-bottom: 1px solid rgba(0,0,0,0.1);
              a{
                font-size:14px;
                font-weight:400;
                color:rgba(0,0,0,0.85);
              }
            }
            li:hover{
              cursor: pointer;
              color:@color-base;
              box-shadow:0 4px 6px 0 rgba(0,141,255,0.1);
              border: none;
            }
            li:hover a{
              color:@color-base;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/checKout/checkout.vue